/* Europe Mark Black Friday product gallery: responsive arrows and pointer-to-zoom. */
(function () {
  'use strict';
  if (window.__emBfGalleryControlsReady) return;
  window.__emBfGalleryControlsReady = true;

  function getVisibleSlides(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return [];
    return Array.from(viewer.querySelectorAll('.product__media-list > .product__media-item'))
      .filter(function (slide) { return !slide.classList.contains('hidden'); });
  }
  function refreshControls(gallery) {
    var controls = gallery.querySelector('.em-bf-gallery-edges');
    if (!controls) return;
    controls.classList.toggle('is-single-visible', getVisibleSlides(gallery).length < 2);
  }
  function removeZoom(gallery) {
    gallery.querySelectorAll('.product__media-item.em-bf-gallery-magnifying').forEach(function (slide) {
      slide.classList.remove('em-bf-gallery-magnifying');
      slide.style.removeProperty('--em-bf-zoom-x');
      slide.style.removeProperty('--em-bf-zoom-y');
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[data-em-bf-gallery-dir]');
    if (!button) return;
    var gallery = button.closest('media-gallery');
    if (!gallery) return;
    event.preventDefault();
    event.stopPropagation();
    removeZoom(gallery);
    var direction = Number(button.getAttribute('data-em-bf-gallery-dir')) || 1;
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;
    if (window.matchMedia('(max-width: 749px)').matches) {
      var nativeArrow = viewer.querySelector(direction > 0 ? '.slider-button--next' : '.slider-button--prev');
      if (nativeArrow) nativeArrow.click();
      refreshControls(gallery);
      return;
    }
    var slides = getVisibleSlides(gallery);
    if (slides.length < 2) return;
    var current = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var nextIndex = (current + direction + slides.length) % slides.length;
    var target = slides[nextIndex];
    if (target && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(target.dataset.mediaId, false);
    }
    refreshControls(gallery);
  });

  // Process high-frequency mouse movement once per animation frame (INP).
  var hoverZoomMedia = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  var pendingHover = null;
  var hoverFrame = 0;
  function flushHoverZoom() {
    hoverFrame = 0;
    var pointer = pendingHover;
    pendingHover = null;
    if (!pointer || !pointer.target.isConnected) return;
    var gallery = pointer.target.closest('media-gallery');
    if (!gallery || !gallery.closest('[id^="MainProduct-"]')) return;
    var opener = pointer.target.closest('.product__media-item.is-active .product__modal-opener--image');
    if (!opener) { removeZoom(gallery); return; }
    var slide = opener.closest('.product__media-item');
    var frame = opener.querySelector('.product__media');
    if (!slide || !frame || !frame.querySelector('img')) return;
    var rect = frame.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = Math.max(0, Math.min(100, (pointer.x - rect.left) * 100 / rect.width));
    var y = Math.max(0, Math.min(100, (pointer.y - rect.top) * 100 / rect.height));
    slide.style.setProperty('--em-bf-zoom-x', x.toFixed(1) + '%');
    slide.style.setProperty('--em-bf-zoom-y', y.toFixed(1) + '%');
    slide.classList.add('em-bf-gallery-magnifying');
  }
  document.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse' || !hoverZoomMedia.matches) return;
    if (!event.target.closest('[id^="MainProduct-"] media-gallery')) return;
    pendingHover = { target: event.target, x: event.clientX, y: event.clientY };
    if (!hoverFrame) hoverFrame = window.requestAnimationFrame(flushHoverZoom);
  }, { passive: true });
  document.addEventListener('pointerout', function (event) {
    var gallery = event.target.closest('media-gallery');
    if (!gallery) return;
    if (!event.relatedTarget || !gallery.contains(event.relatedTarget)) {
      if (hoverFrame) window.cancelAnimationFrame(hoverFrame);
      hoverFrame = 0;
      pendingHover = null;
      removeZoom(gallery);
    }
  }, { passive: true });

  function initialize(scope) {
    scope.querySelectorAll('[id^="MainProduct-"] media-gallery').forEach(refreshControls);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
